<template>
  <div>
    Test dashboard
  </div>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>